// src/components/Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../assets/images/bnwscaffolding.png';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => setIsMobileMenuOpen(prev => !prev);

  return (
    <header className="site-header">
      <div className="logo">
        <Link to="/" className="logo-link" onClick={() => setIsMobileMenuOpen(false)}>
          <img src={logo} alt="B&W Scaffolding Logo" className="logo-image" />
          <span className="logo-text">Scaffolding</span>
        </Link>
      </div>

      {/* Burger menu icon for mobile */}
      <div className="burger" onClick={toggleMobileMenu}>
        <span className="bar" />
        <span className="bar" />
        <span className="bar" />
      </div>

      {/* Navigation links */}
      <nav className={`nav-links ${isMobileMenuOpen ? 'open' : ''}`}>
        <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>Home</Link>
        <Link to="/services" onClick={() => setIsMobileMenuOpen(false)}>Services</Link>
        <Link to="/faq" onClick={() => setIsMobileMenuOpen(false)}>FAQ</Link>
        <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</Link>
        <Link to="/hiring" onClick={() => setIsMobileMenuOpen(false)}>We’re Hiring</Link>
      </nav>

      {/* CTA button (hidden on mobile) */}
      <div className="header-cta">
        <Link to="/contact">
          <button className="cta-button">Get a Quote</button>
        </Link>
      </div>
    </header>
  );
};

export default Header;
